import { render, staticRenderFns } from "./rlzylist.vue?vue&type=template&id=0399ef62&scoped=true&xmlns=http%3A%2F%2Fwww.w3.org%2F1999%2Fhtml&"
import script from "./rlzylist.vue?vue&type=script&lang=js&"
export * from "./rlzylist.vue?vue&type=script&lang=js&"
import style0 from "./rlzylist.vue?vue&type=style&index=0&id=0399ef62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0399ef62",
  null
  
)

export default component.exports